<template>
  <div class="job rounded">
    <WdsStack direction-column>
      <WdsStack justify-space-between>
        <div class="clip-text f-16 f-500">
          <a :href="projectRoute">
            {{ title }}
          </a>
          <div class="f-13 f-500 c-gray clip-text tw-text-clip tw-whitespace-nowrap">
            {{ description }}
          </div>
        </div>

        <WdsButton tertiary>
          <a :href="projectRoute">View Project</a>
        </WdsButton>
      </WdsStack>
      <ProgressBar
        class="tw-pt-5"
        :spent="spent"
        :budget="budget"
        :allocated="allocated"
        :currency="currency"
      ></ProgressBar>
    </WdsStack>
  </div>
</template>

<script>
import { WdsStack, WdsButton } from '@worksome/wds-components'
import BaseLabel from '@/components/BaseLabel.vue'
import HashMixin from '@/mixins/MethodHash'
import ProgressBar from '@/components/Projects/ProgressBar.vue'
import ButtonSplit from '@/components/ButtonSplit.vue'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

export default {
  name: 'ProjectsCardItem',
  // eslint-disable-next-line vue/no-unused-components -- Baseline eslint ignore please fix if working on this
  components: { ButtonSplit, ProgressBar, BaseLabel, WdsStack, WdsButton },
  mixins: [HashMixin],
  props: {
    title: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    currency: {
      type: String,
      required: true,
    },
    budget: {
      type: Number,
      default: null,
    },
    spent: {
      type: Number,
      default: null,
    },
    allocated: {
      type: Number,
      default: null,
    },
  },
  computed: {
    projectRoute() {
      return laravelNamedRoute(namedRoutes.projects.show, { project: this.id })
    },
  },
}
</script>

<style lang="scss" scoped>
.job {
  padding: 12px 13px;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: hsl(0deg 0% 99%) !important;
  }
}

// Hack to break onto a newline after three tags
a:nth-child(3)::after {
  content: '\A';
  white-space: pre;
}

.button-container {
  position: static;
}

a,
.wds-button {
  color: inherit;
  height: fit-content;
}
</style>
